import { i18n } from '@/i18n'

const fieldTypeEmail = { type: 'email', message: i18n.tc('invalidEmail'), trigger: ['blur', 'change'] }

export default fieldTypeEmail
export { fieldTypeEmail }

